import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import BigModal from '../../../../components/Modals/BigModal'

const AddField = ({
  selectedCategory,
  setSelectedCategory,
  data,
  setData,
  setChangesPresent,
  vehicleTypeOptions,
  isVehicleCleans,
}) => {
  const [fieldDuplicate, setFieldDuplicate] = useState(false)
  const [newField, setNewField] = useState(
    isVehicleCleans
      ? {
          title: '',
          cleanType: [],
          vehicleType: [],
        }
      : {
          title: '',
          standard: '',
          applicableTo: ['Frontline Ambulance', 'RRV'],
        }
  )

  return (
    <BigModal open={!!selectedCategory} onClose={() => setSelectedCategory('')}>
      <Stack
        gap={1}
        component="form"
        onSubmit={(e) => {
          e.preventDefault()
          if (data[selectedCategory].some((x) => x.title === newField.title)) {
            setFieldDuplicate(true)
          } else {
            setData((prev) => ({
              ...prev,
              [selectedCategory]: [...prev[selectedCategory], newField],
            }))
            setChangesPresent(true)
            setSelectedCategory('')
            setNewField(
              isVehicleCleans
                ? {
                    title: '',
                    cleanType: [],
                    vehicleType: [],
                  }
                : {
                    title: '',
                    standard: '',
                    applicableTo: ['Frontline Ambulance', 'RRV'],
                  }
            )
          }
        }}
      >
        <Typography variant="title2">
          Add Field to {selectedCategory}
        </Typography>
        <TextField
          value={newField.title}
          label="Title"
          error={fieldDuplicate}
          autoFocus
          helperText={
            fieldDuplicate ? 'Field Already Exists' : 'E.g. Stretcher'
          }
          autoComplete="off"
          required
          InputLabelProps={{ required: false }}
          onChange={(e) =>
            setNewField((prev) => ({ ...prev, title: e.target.value }))
          }
        />
        {!isVehicleCleans && (
          <TextField
            value={newField.standard}
            label="Standard"
            helperText="E.g. Check functioning and Service Date"
            autoComplete="off"
            required
            InputLabelProps={{ required: false }}
            onChange={(e) =>
              setNewField((prev) => ({ ...prev, standard: e.target.value }))
            }
          />
        )}
        {isVehicleCleans && (
          <Grid container spacing={1} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Clean Types:</Typography>
            </Grid>
            {['Interim', 'Deep', 'Decontamination'].map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        newField.cleanType &&
                        newField?.cleanType?.includes(type)
                      }
                      onChange={(e) =>
                        setNewField((prev) => ({
                          ...prev,
                          cleanType: e.target.checked
                            ? [...prev.cleanType, type]
                            : prev.cleanType.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
        {isVehicleCleans && (
          <Grid container spacing={1} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Applicable To:</Typography>
            </Grid>
            {vehicleTypeOptions.map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        newField.vehicleType &&
                        newField?.vehicleType?.includes(type)
                      }
                      onChange={(e) =>
                        setNewField((prev) => ({
                          ...prev,
                          vehicleType: e.target.checked
                            ? [...prev.vehicleType, type]
                            : prev.vehicleType.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
        {!isVehicleCleans && (
          <Grid container spacing={1} padding={1}>
            <Grid item xs={12}>
              <Typography variant="title3">Applicable To:</Typography>
            </Grid>
            {vehicleTypeOptions.map((type) => (
              <Grid item key={type}>
                <FormControlLabel
                  label={type}
                  control={
                    <Checkbox
                      checked={
                        newField.applicableTo &&
                        newField?.applicableTo?.includes(type)
                      }
                      onChange={(e) =>
                        setNewField((prev) => ({
                          ...prev,
                          applicableTo: e.target.checked
                            ? [...prev.applicableTo, type]
                            : prev.applicableTo.filter((x) => x !== type),
                        }))
                      }
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
        <Button type="submit" variant="contained" color="success">
          Submit
        </Button>
      </Stack>
    </BigModal>
  )
}

export default AddField
